package org.chiangmeng.qfast.core.util

import kotlinx.browser.window

actual fun getUrlShopId(): String? {
    return try {
        val href = window.location.href
        val query = if (href.contains("?")) href.substringAfter("?") else return null
        query.split("&")
            .map { it.split("=") }
            .firstOrNull { it.size == 2 && it[0] == "shop" }
            ?.get(1)
            ?.takeIf { it.isNotBlank() }
    } catch (_: Throwable) {
        null
    }
}

actual fun getUrlTicketNumber(): String? {
    return try {
        val href = window.location.href
        val query = if (href.contains("?")) href.substringAfter("?") else return null
        query.split("&")
            .map { it.split("=") }
            .firstOrNull { it.size == 2 && (it[0] == "q" || it[0] == "ticket") }
            ?.get(1)
            ?.takeIf { it.isNotBlank() }
    } catch (_: Throwable) {
        null
    }
}
